import { render, staticRenderFns } from "./TicketsEditor.vue?vue&type=template&id=b17b1dba"
import script from "./TicketsEditor.vue?vue&type=script&lang=js"
export * from "./TicketsEditor.vue?vue&type=script&lang=js"
import style0 from "./TicketsEditor.vue?vue&type=style&index=0&id=b17b1dba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports